import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import ProfilePageSkeleton from "../../profiles/ProfilePageSkeleton";
import SectionSkeleton from "../../profiles/SectionSkeleton";

function ProductHeaderSkeleton() {
  return (
    <div className="card animated faster fadeIn">
      <div className="container-fluid" style={{ padding: "0" }}>
        <div className="row px-3 ps-3">
          <div className="col-auto position-relative d-flex justify-content-center px-4">
            <Skeleton width={120} height={120} containerClassName="my-3" />
          </div>
          <div className="col ms-2 pe-3 ps-3 pt-3">
            <Skeleton width="30%" height={20} containerClassName="d-block mb-2" />
            <Skeleton width="55%" height={32} containerClassName="d-block mb-2" />
            <Skeleton width="15%" height={24} containerClassName="d-block mb-3" />
            <Skeleton width="10rem" height={32} containerClassName="d-block mb-3" />
          </div>
        </div>
      </div>
    </div>
  );
}

// Product's loading state on the shared skeleton chassis. `railHasContent` mirrors the loaded
// page's rail decision so the two share a column layout and load finishes without a reflow.
function ProductShowSkeleton({ railHasContent = true }) {
  return (
    <ProfilePageSkeleton
      header={<ProductHeaderSkeleton />}
      rightRail={
        railHasContent ? (
          <>
            <SectionSkeleton lines={2} />
            <SectionSkeleton lines={3} />
          </>
        ) : null
      }
    >
      <SectionSkeleton lines={5} />
    </ProfilePageSkeleton>
  );
}

ProductShowSkeleton.propTypes = {
  railHasContent: PropTypes.bool,
};

export default ProductShowSkeleton;
